module.exports = __webpack_public_path__ + "img/img_mobile_occupation_gong.da248d16.jpg";